import { useState, useEffect } from "react";
import { useAttemptedQuestions } from "../../context/AttemptedQuestionsContext";
import { decryptData } from "../../crypto";
import { useQuestionRecord } from "../../context/QuestionRecord";

export const useQuestionNavigator = ({ questionData, currentQuestion }) => {
  const [questions, setQuestions] = useState([]);
  const [answered, setAnswered] = useState(0);
  const [marked, setMarked] = useState(0);
  const [notVisited, setNotVisited] = useState(0);
  const [notAnswered, setNotAnswered] = useState(0);
  const [markedWithAnswered, setMarkedWithAnswered] = useState(0);
  const [visitedQuestions, setVisitedQuestions] = useState([0]);

  const { attemptedQuestions } = useAttemptedQuestions();
  const { addQuestionRecord, questionRecords, getQuestionRecordById } =
    useQuestionRecord();

  useEffect(() => {
if(!  attemptedQuestions) return
    attemptedQuestions?.map((question) => {
      addQuestionRecord(question);
    });
  }, [attemptedQuestions]);

  // useEffect(() => {
  //   const examId = sessionStorage.getItem("examId");

  //   const q = questions[currentQuestion];

  //   const data = {
  //     attempt_status: q?.status === "notVisited" ? "not answered" : q?.status === 'markedWithAnswered'? 'marked':q?.status,
  //     exam_id: examId,
  //     question_id: q?.id,
  //     subject_id: q?.subject_id,
  //   };
  //   addQuestionRecord(data);
  // }, [currentQuestion]);

  // Initialize questions
  useEffect(() => {
    if (!questionData || questions.length) return;

    const initialQuestions = questionData.map((q, idx) => ({
      section_id: q.section_id,
      subject_id: q.subject_id,
      id: q.id,
      number: idx + 1,
      status: "notVisited",
    }));
    setQuestions(initialQuestions);
  }, [questionData]);

  // Track visited questions
  useEffect(() => {
    setVisitedQuestions((prev) => {
      const isAlreadyVisited = prev.includes(currentQuestion);
      const questionStatus = questions?.[currentQuestion]?.status;

      if (!isAlreadyVisited && questionStatus === "notVisited") {
        return [...prev, currentQuestion];
      }
      return prev;
    });
  }, [currentQuestion, questions, questionRecords]);

  // Update question statuses based on attempted questions
  useEffect(() => {
    if (questions.length>0 && questionRecords.length>0 && !questionData) return;

    const updatedQuestions = questions?.map((q, idx) => {
      const matched = questionRecords?.find(
        (aq) => Number(aq.question_id) === Number(questionData[idx]?.id)
      );

      let newStatus = q.status;

      if (decryptData(sessionStorage.getItem("exam_template")) !== "default") {
        if (visitedQuestions.includes(idx) && !matched) {
          newStatus = "notAnswered";
        }
      }

      if (matched) {
        if (matched.attempt_status === "attempted") {
          newStatus = "attempted";
        }
        // if (
        //   matched.attempt_status === "attempted" &&
        //   matched.multiple_option_ids?.length === 0
        // ) {
        //   newStatus = "notAnswered";
        // }
        if (
          matched.attempt_status === "not answered" &&
          (!matched.option_id ||
            !matched.multiple_option_ids ||
            matched.multiple_option_ids?.length === 0)
        ) {
          newStatus = "notAnswered";
        }
        if (matched.attempt_status === "marked" && matched.option_id) {
          newStatus = "markedWithAnswered";
        }
        if (matched.attempt_status === "marked" && !matched.option_id) {
          newStatus = "marked";
        }
        if (
          matched.attempt_status === "marked" &&
          !matched.option_id &&
          matched.multiple_option_ids?.length > 0
        ) {
          newStatus = "markedWithAnswered";
        }
      }

      return q.status !== newStatus ? { ...q, status: newStatus } : q;
    });

    const isDifferent = updatedQuestions.some(
      (q, idx) => q.status !== questions[idx].status
    );

    if (isDifferent) {
      setQuestions(updatedQuestions);
    }
  }, [questionRecords, visitedQuestions, questionData]);

  // Calculate and update counts
  useEffect(() => {
    let answeredCount = 0;
    let markedCount = 0;
    let markedWithAnsweredCount = 0;
    let visitedQuestionsCount = 0;

    questions?.forEach((q) => {
      if (q.status === "attempted") answeredCount++;
      else if (q.status === "markedWithAnswered") markedWithAnsweredCount++;
      else if (q.status === "marked") markedCount++;
      else if (q.status === "notAnswered") visitedQuestionsCount++;
    });

    let notVisitedCount =
      questionData?.length -
      (answeredCount +
        markedCount +
        markedWithAnsweredCount +
        visitedQuestionsCount);

    setAnswered(answeredCount);
    setMarked(markedCount);
    setMarkedWithAnswered(markedWithAnsweredCount);
    setNotAnswered(visitedQuestionsCount);
    setNotVisited(notVisitedCount);
  }, [questions, questionData?.length]);

  return {
    questions,
    answered,
    marked,
    notVisited,
    notAnswered,
    markedWithAnswered,
    visitedQuestions,
  };
};
